import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BrandLockup } from "./LogoMark";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F8F9FA]/80 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_4px_24px_rgba(10,25,47,0.05)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <BrandLockup testid="header-logo-link" />
        <div className="flex items-center gap-6">
          <a
            href="/richieste"
            data-testid="header-requests-link"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A192F] hover:text-[#10B981] transition-colors duration-300"
          >
            Richieste attive
          </a>
          <a
            href="#agenzie"
            data-testid="header-agency-link"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-[#0A192F] transition-colors duration-300"
          >
            Sei un'agenzia immobiliare? Clicca qui
            <ArrowRight className="w-3.5 h-3.5" />
          </a>
          <a
            href="#richiesta"
            data-testid="header-cta-button"
            className="inline-flex items-center rounded-full bg-[#0A192F] text-white text-sm font-semibold px-5 py-2.5 hover:bg-[#10B981] transition-colors duration-300"
          >
            Attiva il matching
          </a>
        </div>
      </div>
    </motion.header>
  );
};
